export const FETCH_TEMPLATES = 'FETCH_TEMPLATES'
export const SET_TEMPLATES = 'SET_TEMPLATES'
export const FETCH_TEMPLATE_PREVIEWS = 'FETCH_TEMPLATE_PREVIEWS'
export const SET_TEMPLATE_PREVIEWS = 'SET_TEMPLATE_PREVIEWS'
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const ADD_TEMPLATE = 'ADD_TEMPLATE'
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const FETCH_TEMPLATE_RAW_PREVIEW = 'FETCH_TEMPLATE_RAW_PREVIEW'
export const SET_TEMPLATE_RAW_PREVIEW = 'SET_TEMPLATE_RAW_PREVIEW'
